/* Lettoria NEVERMORE SALE — Nevermore (Lightning) box: one product per slot (30 s) from the slim schedule asset
 * (lettoria-nevermore-lightning-schedule.json, built by lettoria-nevermore-sale/build-lettoria-nevermore-lightning-schedule-asset.mjs):
 *   { start, lend, send, slot(ms), p:[{h,t,img,v,vs:[[id,name,price,compare]],poe}], s:[productIndex per slot] }
 * Slot = floor((now − start) / slot) — timestamps carry −04:00, so the visitor's own time zone never matters.
 * States: pre (teaser + countdown) → live deal (swaps in place, no reload, next photo preloaded) → lightning-ended
 * (points to the Evermore shelf) → sale ended (whole section hidden by CSS). Live stock + price via /products/<h>.js,
 * JSON is the fallback. Ops rule: slot product sold out → show the next scheduled product that is still in stock
 * (same countdown; sold-out handles are remembered for the rest of the visit). Cloned from skullette-spooky-lightning-deals.js.
 * Needs window.LNM. */
(function () {
  var A = window.LNM;
  if (!A) return;
  var box = A.root.querySelector('[data-lnm-ld]');
  var nextWrap = A.root.querySelector('[data-lnm-next]');
  var nextRow = A.root.querySelector('[data-lnm-next-row]');
  var S = null;          // schedule asset
  var shownKey = null;   // 'pre' | 'over' | slot index
  var cur = null;        // { d, idx, at, sel, vars: { id: {name, price, compare, available} } }
  var soldOut = {};      // product index → true once /products/<h>.js says no variant is available
  var SKIP_MAX = 40;     // how far ahead a sold-out slot may look for an in-stock product (20 min)

  A.schedule
    .then(function (j) { S = j; S.t0 = Date.parse(j.start); S.t1 = Date.parse(j.lend); tick(); setInterval(tick, 250); })
    .catch(function () { box.innerHTML = '<p class="lnm-ld__msg">Nevermore deals are loading slowly. Please refresh the page.</p>'; });

  function slotStart(i) { return S.t0 + i * S.slot; }
  function inSched(i) { return i >= 0 && i < S.s.length; }
  function dealAt(i) { return inSched(i) ? S.p[S.s[i]] : null; }
  // first slot ≥ i whose product is not known to be sold out; -1 when the whole look-ahead window is sold out
  function liveSlot(i) {
    for (var k = i; k < i + SKIP_MAX && inSched(k); k++) if (!soldOut[S.s[k]]) return k;
    return -1;
  }
  function inLabel(ms) { var sec = Math.max(0, Math.ceil(ms / 1000)); return 'in ' + (sec < 60 ? sec + 's' : sec < 3600 ? A.mmss(ms) : A.hms(ms)); }
  function poeTag(d) { return d.poe ? '<span class="lnm-poe">Poe</span>' : ''; }

  function tick() {
    var t = A.now();
    var key = t < S.t0 ? 'pre' : t >= S.t1 ? 'over' : Math.floor((t - S.t0) / S.slot);
    if (key !== shownKey) {
      shownKey = key;
      if (key === 'pre') renderPre();
      else if (key === 'over' || !dealAt(key)) renderOver();
      else renderDeal(key);
    }
    updateTimers(key);
  }

  function renderPre() {
    cur = null;
    box.innerHTML = '<div class="lnm-ld__pre"><p class="lnm-ld__pre-k">The first Nevermore deal appears at ' + A.esc(A.whenLabel(S.t0)) + '</p>' +
      '<p class="lnm-ld__pre-t" data-ld-left>' + A.hms(S.t0 - A.now()) + '</p>' +
      '<p class="lnm-ld__pre-s">Then a new deal every ' + S.slot / 1000 + ' seconds until ' + A.esc(A.whenLabel(S.t1 >= A.END ? A.END - 60000 : S.t1)) + '. Keep this page open.</p></div>';
    renderNext(0, -1);
  }

  function renderOver() {
    cur = null;
    box.innerHTML = '<div class="lnm-ld__pre"><p class="lnm-ld__pre-k">Nevermore deals have ended</p>' +
      '<p class="lnm-ld__pre-s">The Evermore shelf is still open. Prices hold until ' + A.esc(A.whenLabel(A.END - 60000)) + '.</p>' +
      '<a class="lnm-btn lnm-btn--ghost" href="#lnm-shelf" data-lnm-jump data-hc-el="hero-cta">Shop the Evermore shelf</a></div>';
    nextWrap.hidden = true;
  }

  // i = clock slot (drives the countdown); at = slot whose product is shown (i, or later when i's product sold out)
  function renderDeal(i) {
    var at = liveSlot(i);
    var allGone = at < 0; // everything ahead is sold out → keep slot i, shown as "Sold out" from the start
    if (allGone) at = i;
    var d = dealAt(at);
    var vars = {};
    d.vs.forEach(function (v) { vars[v[0]] = { name: v[1], price: v[2], compare: v[3], available: !allGone }; });
    cur = { d: d, idx: i, at: at, sel: d.v, vars: vars };
    var url = '/products/' + d.h;
    box.innerHTML =
      '<div class="lnm-ld__card">' +
        '<a class="lnm-ld__media" href="' + url + '" data-lnm-quick="' + A.esc(d.h) + '" data-hc-el="quick-view-open">' +
          // srcset/sizes = the section's inline preload (keep in sync) → the warmed photo is reused
          '<img src="' + A.esc(A.img(d.img, 900)) + '" srcset="' + A.esc(A.img(d.img, 600)) + ' 600w, ' + A.esc(A.img(d.img, 900)) + ' 900w"' +
            ' sizes="(min-width: 900px) 450px, 100vw" fetchpriority="high" alt="' + A.esc(d.t) + '" width="900" height="900">' +
          poeTag(d) + '<span class="lnm-soldout" data-ld-soldout hidden>Sold out</span></a>' +
        '<div class="lnm-ld__info">' +
          '<p class="lnm-ld__timer">Leaves the screen in <b data-ld-left></b></p>' +
          '<div class="lnm-ld__bar"><i data-ld-bar></i></div>' +
          '<h3 class="lnm-ld__title"><a href="' + url + '" data-hc-el="collection-card">' + A.esc(d.t) + '</a></h3>' +
          // anh 10-05: −% next to the price (was a badge on the photo)
          '<p class="lnm-price"><span class="lnm-price__now" data-ld-now></span> <s class="lnm-price__was" data-ld-was></s> <span class="lnm-price__off" data-ld-badge></span></p>' +
          '<p class="lnm-ld__edge" data-ld-edge hidden></p>' +
          (d.vs.length > 1 ? '<div class="lnm-vars" role="radiogroup" aria-label="Leather" data-ld-vars></div>' : '') +
          '<button type="button" class="lnm-btn lnm-btn--big lnm-btn--pulse" data-ld-add data-hc-el="atc">Claim this deal</button>' +
          // Spooky lesson (anh 10-01): Claim = price locked; never promise "won't come back" (products repeat ≥42 min apart)
          '<p class="lnm-ld__claimed" data-ld-claimed hidden>✓ Claimed — price locked in your cart till 11:59 PM ET</p>' +
          '<p class="lnm-ld__note">Claim it now — once the timer hits 0:00 it&#39;s gone from the screen. Claimed = price locked in your cart until ' + A.esc(A.whenLabel(A.END - 60000)) + '. Stock isn&#39;t held, so check out soon.</p>' +
        '</div>' +
      '</div>';
    paint();
    box.querySelector('[data-ld-add]').addEventListener('click', function () {
      var v = cur && cur.vars[cur.sel];
      if (v && v.available) A.runAdd(this, cur.sel, A.img(cur.d.img, 300)).then(function (ok) {
        var c = ok && cur && cur.idx === i && box.querySelector('[data-ld-claimed]');
        if (c) c.hidden = false; // stays until this deal leaves the screen
      });
    });
    renderNext(i + 1, S.s[at]);
    var nd = dealAt(liveSlot(i + 1));
    if (nd) (new Image()).src = A.img(nd.img, 900); // preload the next hero photo
    fetch('/products/' + d.h + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !cur || cur.idx !== i || cur.at !== at) return;
        p.variants.forEach(function (v) {
          var o = cur.vars[v.id];
          if (!o) return;
          o.available = v.available;
          o.price = v.price / 100;
          o.compare = (v.compare_at_price || 0) / 100;
        });
        var ids = Object.keys(cur.vars);
        if (!ids.some(function (id) { return cur.vars[id].available; })) {
          // whole product sold out → ops rule: next scheduled product still in stock, same countdown
          soldOut[S.s[at]] = true;
          if (liveSlot(i) > -1) { renderDeal(i); return; } // an in-stock product is still ahead → swap to it
        } else if (!cur.vars[cur.sel].available) { // featured (cheapest) variant sold out → preselect another one
          cur.sel = Number(ids.filter(function (id) { return cur.vars[id].available; })[0]);
        }
        paint();
      })
      .catch(function () {});
  }

  // Price / badge / pills / button for the current selection. The button says exactly what gets added
  // ("Claim Vegan · $50.95") — DD lost 28% of adds to cart removals.
  function paint() {
    var v = cur.vars[cur.sel];
    var ids = cur.d.vs.map(function (x) { return x[0]; });
    var labels = A.variantLabels(cur.d.vs.map(function (x) { return x[1]; }), true);
    var anyAvail = ids.some(function (id) { return cur.vars[id].available; });
    box.querySelector('[data-ld-now]').textContent = A.money(v.price);
    box.querySelector('[data-ld-was]').textContent = v.compare > v.price ? A.money(v.compare) : '';
    var off = A.pct(v.price, v.compare);
    // Lightning edge (Spooky: Lightning adds/view −62% once the shelf competed). Builder sets e = [type label, best Evermore %
    // of that type]; the line shows only while the selected variant really beats it (Top-Grain may not).
    var edge = box.querySelector('[data-ld-edge]');
    edge.hidden = !(cur.d.e && off > cur.d.e[1]);
    if (!edge.hidden) edge.textContent = 'Deeper than any ' + cur.d.e[0] + ' deal on the Evermore shelf';
    var badge = box.querySelector('[data-ld-badge]');
    badge.textContent = off ? '−' + off + '%' : '';
    badge.hidden = !off;
    box.querySelector('[data-ld-soldout]').hidden = anyAvail;
    var btn = box.querySelector('[data-ld-add]');
    if (!btn.classList.contains('is-added')) {
      btn.disabled = !v.available;
      btn.textContent = !v.available ? 'Sold out' : ids.length > 1 ? 'Claim ' + labels[ids.indexOf(cur.sel)] + ' · ' + A.money(v.price) : 'Claim this deal · ' + A.money(v.price);
    }
    var wrap = box.querySelector('[data-ld-vars]');
    if (!wrap) return;
    wrap.innerHTML = cur.d.vs.map(function (x, k) {
      var o = cur.vars[x[0]];
      return '<button type="button" role="radio" class="lnm-var' + (x[0] === cur.sel ? ' is-on' : '') + '" aria-checked="' + (x[0] === cur.sel) + '"' +
        (o.available ? '' : ' disabled') + ' data-v="' + x[0] + '" data-hc-el="variant-picker">' +
        A.esc(labels[k]) + ' <b>' + A.money(o.price) + '</b></button>';
    }).join('');
    wrap.querySelectorAll('[data-v]').forEach(function (b) {
      b.addEventListener('click', function () { cur.sel = Number(b.dataset.v); paint(); });
    });
  }

  // Up next (brief: photos + time only, never name or price): next 4 slots, skipping the product on screen now
  // (a sold-out swap can pull it forward) and known sold-out products.
  function renderNext(from, onScreen) {
    var items = [];
    for (var k = from; items.length < 4 && inSched(k) && k < from + 12; k++) {
      if (S.s[k] !== onScreen && !soldOut[S.s[k]]) items.push(k);
    }
    nextWrap.hidden = !items.length;
    nextRow.innerHTML = items.map(function (k) {
      var d = dealAt(k);
      var f = d.vs.filter(function (x) { return x[0] === d.v; })[0] || d.vs[0];
      var off = A.pct(f[2], f[3]);
      return '<div class="lnm-next__item"><div class="lnm-next__img"><img src="' + A.esc(A.img(d.img, 300)) + '" alt="Upcoming deal" loading="lazy" width="300" height="400">' +
        (off ? '<span class="lnm-next__off">−' + off + '%</span>' : '') + '</div>' +
        '<span data-next-at="' + k + '">' + inLabel(slotStart(k) - A.now()) + '</span></div>';
    }).join('');
  }

  function updateTimers(key) {
    nextRow.querySelectorAll('[data-next-at]').forEach(function (el) { el.textContent = inLabel(slotStart(+el.dataset.nextAt) - A.now()); });
    var left = box.querySelector('[data-ld-left]');
    if (!left) return;
    if (key === 'pre') { left.textContent = A.hms(S.t0 - A.now()); return; }
    if (!cur) return;
    var remain = slotStart(cur.idx + 1) - A.now();
    left.textContent = A.mmss(remain);
    var bar = box.querySelector('[data-ld-bar]');
    if (bar) bar.style.width = Math.max(0, Math.min(100, remain / S.slot * 100)) + '%';
  }
})();
